import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ScreenNotificationDefault} from '../../components';
import {redirectToValidationAccessCode} from '../../ducks/Navigate';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

class CodeExpired extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.CodeExpired.title);
  }

  render() {
    return (
      <ScreenNotificationDefault
        title={<p>Código Expirado!</p>}
        content={
          <div>
            <p>Ops, não deu certo :(</p>
            <p>Campanha encerrada ou Código já utilizado.</p>
          </div>
        }
        textButton="Fechar"
        actionButton={() => {
          this.props.redirectToValidationAccessCode();
        }}
      />
    );
  }
}

const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, {
  redirectToValidationAccessCode,
})(CodeExpired);
